import blockCampaign from "../../components/others/_block-campaign.js";
import { setCountAction, setTypeToggle } from "../search/_common.js";
import homeHero from "./_hero.js";

const homeCampaigns = async () => {
    const root = document.querySelector('[data-campaign-async]');
    if (!root) return;

    const list = root.querySelector('[data-campaign-list]');
    const url = root.dataset.url;
    if (!list || !url) return;

    try {
        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!response.ok) throw new Error(`Failed to load campaigns: ${response.status}`);

        const data = await response.json();
        if (!data.html || Number(data.count) === 0) return;

        list.innerHTML = data.html;
        root.hidden = false;
        blockCampaign();
    } catch (error) {
        root.hidden = true;
        console.error(error);
    }
};

// エリアTOPページに埋め込んだ「エリアからさがす」(/search/areaと同じ内容の使い回し)の
// 種別トグル・チェックボックス選択時の件数表示を初期化する。
// setCountAction()はCountAction.on()が対象要素なしだとエラーになるため、
// 対象要素の有無を確認してから呼び出す(setTypeToggle()側は内部でガード済み)
const homeAreaSearch = () => {
    setTypeToggle();
    if (document.querySelector('[data-pickup-search]')) {
        setCountAction();
    }
};

export { homeCampaigns, homeAreaSearch, homeHero };
export default homeCampaigns;
